import { createApp } from 'vue'
import { pinia } from './pinia'
import './style.css'
import App from './App.vue'
import router from './router'
import { initConsoleBuffer } from './composables/useConsoleBuffer'

initConsoleBuffer();

const app = createApp(App)

app.use(pinia)
app.use(router)

app.mount('#app')


